@if (activityMessages$ | async) {
    <div
        class="d-flex justify-content-between"
        [class.pb-4]="this.activity().channelType !== 'voice'"
    >
        <div class="d-flex justify-content-start">
            <telxl-button
                colour="notes"
                [outline]="true"
                [className]="displayNote() ? 'active' : ''"
                [disabled]="!hasAvailableNote()"
                (buttonClick)="toggleNoteDisplay()"
            >
                <i class="fa-lg fa-light fa-note"></i>
                <span class="ps-2">Notes</span>
            </telxl-button>
        </div>
        @if (this.activity().channelType !== 'voice') {
            <div class="d-flex justify-content-end gap-2">
                <span [ngbTooltip]="isAiSummaryEnabledToolTip()">
                    <telxl-button
                        #summaryBtn="ngbTooltip"
                        colour="ai"
                        [style.cursor]="'pointer'"
                        [active]="summarising()"
                        [outline]="true"
                        [ngbTooltip]="summaryTemplate"
                        [tooltipClass]="'summary-tooltip'"
                        [autoClose]="false"
                        [disabled]="!isAiSummaryEnabled()"
                        triggers="manual"
                        placement="bottom-end"
                        (buttonClick)="toggleSummaryTooltip(summaryBtn)"
                        (shown)="summarising.set(true)"
                        (hidden)="summarising.set(false)"
                    >
                        <i class="fa-light fa-bolt-lightning"></i>
                        Ai Summary
                    </telxl-button>
                </span>
                <telxl-button
                    colour="dark"
                    [outline]="true"
                    (buttonClick)="download()"
                >
                    Download
                </telxl-button>
            </div>
        }
    </div>

    @if (displayNote()) {
        <div
            class="note-container p-4 mb-4 font-s"
            (click)="toggleNoteDisplay()"
            (keydown)="toggleNoteDisplay()"
            tabindex="0"
        >
            <div class="note-container__heading pb-3">
                Note from: {{ activity().agent?.name }}
            </div>
            <div class="note-container__content">
                {{ activity().notes }}
            </div>
        </div>
    }

    <div class="d-flex flex-column font-xs">
        @if (isChatHistory()) {
            <div class="d-flex justify-content-center weight-medium">
                {{ dateOfChat() }}
            </div>
            <div class="d-flex justify-content-center">
                Chat started
                <span class="weight-medium">
                    &nbsp;&centerdot; {{ timeOfChat() }}
                </span>
            </div>
            <div class="mt-4">
                <telxl-shared-chat-history
                    [messages]="chatActivityMessages()"
                    [channel]="activity().channelType"
                />
            </div>
        } @else {
            <telxl-shared-email-history [messages]="emailActivityMessages()" />
        }
    </div>
}

<ng-template #summaryTemplate>
    <div class="p-2">
        @if (loading()) {
            <div class="d-flex align-items-center gap-2">
                <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                ></span>
                <span>Summarising…</span>
            </div>
        } @else {
            <div>{{ summary() }}</div>
        }
    </div>
</ng-template>
